import initLegacyPublicBridge from '~/modules/legacyPublicBridge.js';
import { initComposerCatalogForm } from '~/modules/ComposerCatalogForm.js';
import { initLabelInstoreSelection } from '~/modules/LabelInstoreSelection.js';

document.addEventListener('DOMContentLoaded', () => initComposerCatalogForm());
document.addEventListener('turbo:load', () => initComposerCatalogForm());
document.addEventListener('DOMContentLoaded', () => initLabelInstoreSelection());
document.addEventListener('turbo:load', () => initLabelInstoreSelection());

let browserRoot = initLegacyPublicBridge();
window.EventHub = browserRoot.EventHub;
window.Audiocrowd = window.Audiocrowd || {};
window.Audiocrowd.EventHub = browserRoot.EventHub;

// // import $ from 'jquery';

// $.ajaxSetup({
//   headers: {
//     'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
//   }
// });

import AudioPlayer from '~/modules/AudioPlayer.js';
import { initRollbarClient } from '~/modules/RollbarClient.js';
import TrackShowLicenseTrigger from '~/modules/TrackShowLicenseTrigger.js';

initRollbarClient();

AudioPlayer.init();
TrackShowLicenseTrigger.init();

import '~/modules/ConversionTracking.js';
import Cart from '~/components/legacy/Cart.jsx';
import '~/components/legacy/CheckoutContinueButtonGuard.js';
import '~/components/legacy/CheckoutSelectionHistoryRefreshGuard.js';
import CheckoutProjectLicenseConfigurator from '~/components/legacy/CheckoutProjectLicenseConfigurator.jsx';
import InlineLicenseConfig from '~/components/legacy/InlineLicenseConfig.jsx';
import LicenseNavigatorV2Demo from '~/components/legacy/LicenseNavigatorV2Demo.jsx';
import LicenseNavigatorV2Flow from '~/components/legacy/LicenseNavigatorV2Flow.jsx';
import PricingProjectLicenseFlow from '~/components/legacy/PricingProjectLicenseFlow.jsx';
import Search from '~/components/legacy/Search.jsx';
import SearchMenuInvisible from '~/components/legacy/SearchMenuInvisible.jsx';
import SmartNavigatorFlow from '~/components/legacy/SmartNavigatorFlow.jsx';
import SoundEffectInfo from '~/components/legacy/SoundEffectInfo.jsx';
import SoundEffectListing from '~/components/legacy/SoundEffectListing.jsx';
import SoundEffectSearchMenuInvisible from '~/components/legacy/SoundEffectSearchMenuInvisible.jsx';
import SoundEffectListingSortInputs from '~/components/legacy/SoundEffectListingSortInputs.jsx';
import SoundEffectSearch from '~/components/legacy/SoundEffectSearch.jsx';
import StaticTrackListing from '~/components/legacy/StaticTrackListing.jsx';
import ProjectTrackListing from '~/components/legacy/ProjectTrackListing.jsx';
import SubscriptionTierOverview from '~/components/legacy/SubscriptionTierOverview.jsx';
import TrackFavorites from '~/components/legacy/TrackFavorites.jsx';
import TrackHeroActionBar from '~/components/legacy/TrackHeroActionBar.jsx';
import TrackInfo from '~/components/legacy/TrackInfo.jsx';
import TrackListing from '~/components/legacy/TrackListing.jsx';
import TrackListingSortInputs from '~/components/legacy/TrackListingSortInputs.jsx';
import TrackWaveformPlayer from '~/components/legacy/TrackWaveformPlayer.jsx';
import AudioToolUpload from '~/components/AudioToolUpload.jsx';
import BatchLoudnessMatchingUpload from '~/components/BatchLoudnessMatchingUpload.jsx';

import confetti from 'canvas-confetti';
window.confetti = confetti;

// To see this message, add the following to the `<head>` section in your
// views/layouts/application.html.erb
//
//    <%= vite_client_tag %>
//    <%= vite_javascript_tag 'application' %>
console.log('Vite ⚡️ Rails')

// If using a TypeScript entrypoint file:
//     <%= vite_typescript_tag 'application' %>
//
// If you want to use .jsx or .tsx, add the extension:
//     <%= vite_javascript_tag 'application.jsx' %>

console.log('Visit the guide for more information: ', 'https://vite-ruby.netlify.app/guide/rails')

// Example: Load Rails libraries in Vite.
//
// import * as Turbo from '@hotwired/turbo'
// Turbo.start()
//
// import ActiveStorage from '@rails/activestorage'
// ActiveStorage.start()
//
// // Import all channels.
// const channels = import.meta.globEager('./**/*_channel.js')

// Example: Import a stylesheet in app/frontend/index.css
// import '~/index.css'

// let cartElements = document.querySelectorAll('[data-react-component=Cart]');

// cartElements.forEach(function(element) {
//   let reactProps = element.dataset.props;

//   ReactDOM.render(
//     <React.StrictMode>
//       <Cart props={reactProps} />
//     </React.StrictMode>,
//     element
//   );
// })

import globalModule from '~/modules/global.js';
import { initAudioToolCtaTracking } from '~/modules/AudioToolCtaTracking.js';
import { initPodcastIntroFinderAnalytics } from '~/modules/PodcastIntroFinderAnalytics.js';
import { initChristmasMarketPricing } from '~/modules/ChristmasMarketPricing.js';
import { initChristmasMarketPurchaseTracking } from '~/modules/ChristmasMarketPurchaseTracking.js';
import { initChristmasHomepageCampaign } from '~/modules/ChristmasHomepageCampaign.js';
import { initChristmasMarketOfferVatId } from '~/modules/ChristmasMarketOfferVatId.js';
import { initChristmasMarketOfferAccess } from '~/modules/ChristmasMarketOfferAccess.js';
import { initSongolinoAdminImport } from '~/modules/SongolinoAdminImport.js';

window.Audiocrowd.Global = globalModule;

document.addEventListener('DOMContentLoaded', function() {
    globalModule.init();
    initAudioToolCtaTracking();
    initPodcastIntroFinderAnalytics();
    initChristmasMarketPricing();
    initChristmasMarketPurchaseTracking();
    initChristmasHomepageCampaign();
    initChristmasMarketOfferVatId();
    initChristmasMarketOfferAccess();
    initSongolinoAdminImport();
});


import TrackTextGenerator from '~/modules/TrackTextGenerator.js';
window.Audiocrowd.TrackTextGenerator = TrackTextGenerator;
